export default __webpack_public_path__ + "static/media/transaccionexitosa.9b3832ba.svg";